import styled from 'styled-components';

export const Root = styled.div`
`;

export const Bottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0px;
`;